package dev.lingvo.site.pages.app.projects.slug.screenshots

/** Fixed-table widths include one gap between each column and one at either outside edge. */
internal object CoverageGridSizing {
    const val SHOT_WIDTH = 112
    const val MIN_CELL_WIDTH = 64
    const val MAX_CELL_WIDTH = 160
    const val GAP = 4

    fun minWidth(languages: Int): Int = width(languages, MIN_CELL_WIDTH)
    fun maxWidth(languages: Int): Int = width(languages, MAX_CELL_WIDTH)

    private fun width(languages: Int, cellWidth: Int): Int =
        SHOT_WIDTH + languages * cellWidth + (languages + 2) * GAP
}
